import { AnyAction } from '@reduxjs/toolkit'

import { FETCH_SPACE_MEMBERS_SEARCH_SUCCESS } from '@/pages/SpaceMemberEditPage/actionTypes'
import { ADD_MEMBER_TO_SPACE_SUCCESS, CHANGE_CURRENT_SPACE, FETCH_USER_SUCCESS } from '@/store/actionTypes'

import {
  FETCH_SPACE_MEMBERS_SUCCESS,
  REMOVE_MEMBER_FROM_SPACE_SUCCESS,
  RESET_SPACE_MEMBERS_PAGINATION_STATE,
  SET_EDIT_SPACE_MEMBER,
  SET_FILTER_SPACE_MEMBER,
  SET_NEW_SPACE_MEMBER,
  SET_SPACE_MEMBERS_SORTING_STATE
} from './actionTypes'

type SpaceMembersPageState = {
  page?: string[]
  totalUsers?: number
  startIndex?: number
  searchedUsersNew?: string[]
  sortingColumn?: unknown
  isEditingUser?: boolean
  isNewUser?: boolean
  filter?: string
  user?: unknown
  reset?: boolean
}

const initialState: SpaceMembersPageState = {}

export default (state = initialState, action: AnyAction): SpaceMembersPageState => {
  switch (action.type) {
    case FETCH_SPACE_MEMBERS_SEARCH_SUCCESS: {
      return {
        ...state,
        searchedUsersNew: action.response.resources.map(({ id }: { id: string }) => id)
      }
    }
    case FETCH_SPACE_MEMBERS_SUCCESS: {
      return {
        ...state,
        page: action.response.resources.map(({ id }: { id: string }) => id),
        totalUsers: action.response.totalResults,
        startIndex: action.response.startIndex
      }
    }

    case SET_SPACE_MEMBERS_SORTING_STATE: {
      return { ...state, sortingColumn: action.sortingColumn }
    }

    case SET_EDIT_SPACE_MEMBER: {
      return { ...state, isEditingUser: action.isEditingUser, isNewUser: false }
    }

    case SET_NEW_SPACE_MEMBER: {
      return { ...state, isNewUser: action.isNewUser, user: null, searchedUsersNew: [] }
    }

    case SET_FILTER_SPACE_MEMBER: {
      return { ...state, filter: action.filter }
    }

    case RESET_SPACE_MEMBERS_PAGINATION_STATE:
    case ADD_MEMBER_TO_SPACE_SUCCESS:
    case REMOVE_MEMBER_FROM_SPACE_SUCCESS:
    case CHANGE_CURRENT_SPACE: {
      return {
        ...state,
        sortingColumn: null,
        startIndex: 1,
        totalUsers: 0,
        page: [],
        isEditingUser: false,
        isNewUser: false,
        filter: '',
        reset: true
      }
    }
    case FETCH_USER_SUCCESS: {
      // if the state changed to adding a user then don't use the outdated fetch
      return { ...state, user: state.isNewUser ? null : action.response }
    }

    default: {
      return state
    }
  }
}
